export const LOAD_SEARCH_ID = "LOAD_SEARCH_ID";
export const LOAD_SEARCH_ID_SUCCESS = "LOAD_SEARCH_ID_SUCCESS";
export const SET_STATUS = "SET_STATUS";
export const SET_FILTER_NUMBER_STOPS = "SET_FILTER_NUMBER_STOPS";
export const SET_SORT = "SET_SORT";
